import type { ReactNode } from 'react'
import { AppLoader } from '@/lib/router/components'
import { cn } from '@/lib/utils'

interface PageProps {
  children: ReactNode
  className?: string
  isLoading?: boolean
  noPadding?: boolean
  /**
   * Pins the column to its parent's height as a flex chain. It carries no
   * bottom padding: the column is exactly as tall as the frame, so scrolling
   * happens in its children and a bottom pad would only be a dead band under
   * them. Scroll clearance for growing pages lives on PageContainer's content
   * column instead.
   */
  fullHeight?: boolean
}

export function Page({
  children,
  className,
  isLoading,
  noPadding,
  fullHeight,
}: PageProps) {
  const containerClassName = cn(
    !noPadding && 'px-3 sm:px-4 md:px-6 lg:px-8',
    noPadding && 'p-0',
    fullHeight && 'flex h-full flex-col',
    className,
  )

  return (
    <div className={containerClassName}>
      {isLoading ? <AppLoader inline size="sm" /> : children}
    </div>
  )
}
